import { atom } from "jotai";
import type { T_Interval } from "./non-draggable-stock-price-chart";

export const interval_atom = atom<T_Interval>("1D");
